import type React from 'react';
import { Tag } from '@jem-open/jem-ui';
import type { TransactionStatus } from './types';

// Shared transaction-status → UI mapping for the savings payment surfaces
// (submission breakdown + batch items), so the taxonomy can't drift between
// them when it changes again (ENG-4670).
//
// SUBMITTED/PROCESSED = paid/submitted to the provider; SKIPPED = excluded
// (no provider account); FAILED = errored; PENDING = not yet paid.
export const statusVariant = (
  status: TransactionStatus
): React.ComponentProps<typeof Tag>['variant'] => {
  switch (status) {
    case 'SUBMITTED':
    case 'PROCESSED':
      return 'success';
    case 'SKIPPED':
      return 'warning';
    case 'FAILED':
      return 'failed';
    case 'PENDING':
    default:
      return 'pending';
  }
};

export const PAID_STATUSES: TransactionStatus[] = ['SUBMITTED', 'PROCESSED'];
